<template>
    <div v-if="!intoshare" class="sharedef">
        <div class="share-content">
            <div class="share-log">
                <el-input type="password" v-model="pwd" class="share-input" placeholder="分享已加密，请输入密码查看"></el-input>
                <el-button type="primary" class="confirm-btn" size="medium" @click="topro">确定</el-button>
            </div>
        </div>
    </div>
    <component :is="getComp(tempactive)" :temdata="temdata" :isFirst="isFirst" v-else></component>
</template>

<script>
import {proshare, checkProPwd} from '@/api/new'
const requireTemp = require.context('../../components/temp', false, /\.vue$/)
export default {
    data() {
        return {
            templist: [],
            tempactive: 'template2',
            temdata: {},
            isFirst: false,
            intoshare: false,
            pwd: '',
            ids: ''
        }
    },
    mounted() {
        var projectId = this.$route.query.projectId
        this.ids = projectId
        this.checkPwd(projectId)
        // this.getTemid(projectId)
    },
    methods: {
        checkPwd(ids) {
            const params = {
                ids: ids
            }
            checkProPwd(params).then(res => {
                if (!res.isNeedPwd) {
                    this.getTemid(ids)
                    this.intoshare = true
                }
            })
        },
        loadTemp() {
            const componentemp = requireTemp.keys().map(key => requireTemp(key))
            const loadhead = componentemp.map(component => component.default)
            this.templist = loadhead
        },
        getComp(name) {
            let comp = this.templist.find(item => item.name == name)
            return comp
        },
        getTemid(id) {
            const params = {
                ids: id
            }
            proshare(params).then(res => {
                if (res.status == 200) {
                    this.tempactive = res.data.template_local_id
                    this.temdata = res.data
                    this.isFirst = this.temdata.isFirst
                    this.loadTemp()
                } else {
                    this.$message.warning(res.msg || '该项目已删除')
                }
            })
        },
        topro() {
            const params = {
                ids: this.ids,
                pwd: this.pwd
            }
            proshare(params).then(res => {
                if (res.status == -1) {
                    this.$message.warning('分享密码错误')
                } else if (res.status == 200) {
                    this.tempactive = res.data.template_local_id
                    this.temdata = res.data
                    this.isFirst = this.temdata.isFirst
                    this.loadTemp()
                    this.intoshare = true
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.sharedef {
    width: 100%;
    height: 100%;
    background: url(@/assets/pic1.jpg) no-repeat;
    background-size: 100% 100%;
    position: relative;
    .share-content{
        position: absolute;
        width: 100%;
        height: 100%;
        backdrop-filter: blur(20px);
        left: 0;
        top: 0;
    }
    .share-log {
        margin-top: 19%;
        text-align: center;
        .share-input {
            width: 364px;
            margin: 42px auto 0;
            height: 64px;
            font-size: 24px;
        }
        .confirm-btn {
            height: 64px;
            width: 120px;
            margin-left: 12px;
            font-size: 24px;
        }
    }
}
</style>
<style lang="scss">
.sharedef {
    .share-log {
        .share-input {
            .el-input__inner {
                height: 64px;
                line-height: 64px;
                text-align: center;
            }
        }
    }
}
</style>